import { useParams } from "react-router-dom";

import { useGetBlacklistSchemasQuery } from "src/graphql/anti-fraud/queries/blacklists/BlacklistSchemasQuery.ts";
import { ClientSchemaBlacklist } from "src/types/clientSchema";

export const useListSchema = () => {
  const params = useParams<{ code: string }>();
  const { data: blacklistSchemas } = useGetBlacklistSchemasQuery();
  const listSchema: ClientSchemaBlacklist | undefined = blacklistSchemas.find(
    (schema) => schema.code === params.code
  );
  return { listSchema };
};
